import React from 'react';
import Widget from "./widget";
import {TableView, TableHeader, Column, Row, TableBody, Cell, Flex, View} from '@adobe/react-spectrum';
import useDashboard from "state/dashboard/hooks/useDashboard";
import CheckmarkCircle from "@spectrum-icons/workflow/CheckmarkCircle";
import styled from "styled-components";

const Description = styled.div`
  color: #6E6E6E;
  text-transform: capitalize;
`;

const renderFromDate = item => {
  return new Date(JSON.parse(item.result).from).toDateString();
}

const renderToDate = item => {
  return new Date(JSON.parse(item.result).to).toDateString();
}

const renderTotalBandwidth = item => {
  return JSON.parse(item.result).total_bytes
}

const renderTotalBandwidthTB = item => {
  let data = JSON.parse(item.result);

  if (data.total_tb_binary.includes("0") || data.total_tb_binary.includes("0.")) {
    return <View><p>Year Worth of Data Served By Fastly In GB:</p><p>Total Bandwidth (Binary GB): {data.total_gb_binary}</p>
      <p>Total Bandwidth (Decimal GB): {data.total_gb_decimal}</p></View>
  }

  return <View><p>Year Worth of Data Served By Fastly In TB:</p><p>Total Bandwidth (Binary TB): {data.total_tb_binary}</p>
    <p>Total Bandwidth (Decimal TB): {data.total_tb_decimal}</p></View>
};

const FastlyInfoWidget = layoutItem => {
  const [dashboard,,] = useDashboard();

  if (dashboard.widget.fastlyInfo.length === 0) {
    return <Widget title={'Fastly Info'}>
      <Flex direction={'column'} alignItems={'center'} justifyContent={'center'} height="100%" width="100%">
        <CheckmarkCircle color={'positive'} size={'XL'} marginBottom={'10px'}/>
        <Description>No Information Available</Description>
      </Flex>
    </Widget>
  }

  return <Widget layoutItem={layoutItem} title="Fastly Info">
    {
      dashboard.widget.fastlyInfo.map((item) => <Flex width={'100%'} direction="column" UNSAFE_style={{overflow: 'hidden'}} key={item.id}>
        <TableView aria-label="Fastly Info" flexGrow isQuiet UNSAFE_style={{margin: '0 -1rem' ,border:'none'}}>
          <TableHeader>
            <Column align={'start'} width={'26%'}>From</Column>
            <Column align={'start'} width={'26%'}>To</Column>
            <Column align={'start'} width={'48%'}>Total Bandwidth (bytes)</Column>
          </TableHeader>
          <TableBody UNSAFE_stye={{border:'none'}} >
            <Row>
              <Cell>{renderFromDate(item)}</Cell>
              <Cell>{renderToDate(item)}</Cell>
              <Cell>{renderTotalBandwidth(item)}</Cell>
            </Row>
          </TableBody>
        </TableView>
        <Flex direction="row" UNSAFE_style={{display: 'block', marginTop: '30px'}}>
          {renderTotalBandwidthTB(item)}
        </Flex>
      </Flex>
      )
    }
    </Widget>;
};

export default FastlyInfoWidget;
